import { useMutation, useQueryClient } from "react-query";
import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { serializeQuery } from "@xtribe/shared/lib/text-transformations";
import { IFetchSpaceGroup } from "./types";
import { SpaceGroupsData } from "../useSpaceGroups/types";

function useEditSpaceGroup() {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, ...props }: any) =>
      axios
        .post(`/api/v1/space-groups/${id}/edit`, props)
        .then((res) => res.data)
        .catch((error) => {
          if (error?.response?.data?.message) {
            throw new Error(error?.response?.data?.message);
          } else throw error;
        }),
    {
      onSuccess: (data, props) => queryClient.invalidateQueries("space-groups"),
    }
  );
}
function useArchiveSpaceGroup() {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, ...props }: { id: string; teamId: string }) =>
      axios
        .post(`/api/v1/space-groups/${id}/archive`, props)
        .then((res) => res.data)
        .catch((error) => {
          if (error?.response?.data?.message) {
            throw new Error(error?.response?.data?.message);
          } else throw error;
        }),
    {
      onSuccess: (data, props) => {
        queryClient.invalidateQueries("space-groups");
        queryClient.invalidateQueries("spaces");
        queryClient.invalidateQueries("content");
      },
    }
  );
}

async function fetchSpaceGroup({
  id,
  ...props
}: IFetchSpaceGroup): Promise<SpaceGroupsData> {
  const query = serializeQuery({
    ...props,
  });
  try {
    const res = await axios.get(
      `/api/v1/space-groups/${id}/get${query ? "?" + query : ""}`
    );
    return res.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      throw new Error(error?.response?.data?.message);
    } else throw error;
  }
}

function useSpaceGroup<TData = SpaceGroupsData>(
  props: IFetchSpaceGroup,
  options?: UseQueryOptions<SpaceGroupsData, AxiosError, TData>
) {
  return useQuery(
    ["space-group", { ...props }],
    () => fetchSpaceGroup({ ...props }),
    options
  );
}

export {
  useSpaceGroup,
  fetchSpaceGroup,
  useEditSpaceGroup,
  useArchiveSpaceGroup,
};
